class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      //  this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
      this.removeHighlight();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const selectedOptions = Array.from(this.querySelectorAll('[data-option-group] input:checked'));
    // Check if all options have been selected
    if (selectedOptions.length === this.querySelectorAll('[data-option-group]').length) {
      // All options have been selected, proceed with further logic
      const optionValues = selectedOptions.map((option) => option.value);
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.options.every((option, index) => option === optionValues[index]);
      });
    } else {
      // Not all options have been selected, return null for this.currentVariant
      this.currentVariant = null;
    }
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent('variant-change', {
        bubbles: true,
        variant: this.currentVariant,
        detail: {
          variant: this.currentVariant,
        },
      })
    );
  }

  dispatchVariantChangeComplete() {
    document.dispatchEvent(
      new CustomEvent('variant-change-complete', {
        bubbles: true,
        variant: this.currentVariant,
        detail: {
          variant: this.currentVariant,
        },
      })
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const ids = [
          `price-${this.dataset.section}`,
          `product-form-${this.dataset.section}`,
          `[data-add-to-birthlist]`,
          `sticky-atc-${this.dataset.section}`,
        ];

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        ids.forEach((id) => {
          const destination = document.getElementById(id);
          const source = html.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML;
        });

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('hidden');
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        if (document.querySelector(`#product-form-${this.dataset.section}`)) {
          // Update the inventory quantity hidden input
          const inventoryQtyDestination = document
            .querySelector(`#product-form-${this.dataset.section}`)
            .querySelector('input[name="inventory_quantity"]');

          const inventoryQtySource = html
            .querySelector(`#product-form-${this.dataset.section}`)
            .querySelector('input[name="inventory_quantity"]');
          inventoryQtyDestination.value = inventoryQtySource.value;
        }

        this.dispatchVariantChangeComplete();
      });
  }

  /**
   * toggleAddButton
   * @param {Boolean} disable
   * @param {String} text
   * @param {Boolean} modifyClass
   * @returns {void}
   */

  setButtonState(button, enabled = true) {
    if (enabled == false) {
      button.setAttribute('disabled', true);

      if (button.dataset.bisEnabled && button.dataset.bisEnabled === 'true') {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (input.value !== '') {
            button.style.display = 'none';
          }
        });
      }
    } else {
      button.removeAttribute('disabled');
      button.style.display = 'flex';
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let addButton = null;
    let birthlistMode = false;
    if (document.getElementById(`product-form-${this.dataset.section}`)) {
      addButton = document
        .getElementById(`product-form-${this.dataset.section}`)
        ?.querySelector('[name="add"]');
    } else if (!addButton) {
      addButton = document.querySelector('[data-main-add-to-birthlist]');
      birthlistMode = true;
    }

    if (birthlistMode === false && addButton !== null) {
      const addButtonText = addButton.querySelector('[data-add-to-cart-button-text]');
      const mobileStickyATC = document.querySelector('sticky-mobile-atc');
      const mobileStickyATCButton = mobileStickyATC?.querySelector('button[name="add"]');
      const mobileStickyATCText = mobileStickyATC?.querySelector('[data-add-to-cart-button-text]');

      document
        .getElementById(`product-form-${this.dataset.section}`)
        ?.querySelector('[data-klaviyo-bis-trigger]');

      if (!addButton || !addButtonText || !mobileStickyATCButton) return;

      if (disable) {
        this.setButtonState(addButton, false);
        this.setButtonState(mobileStickyATCButton, false);
        // if (mobileStickyATC) {
        //   mobileStickyATC.closest('sticky-mobile-atc').classList.add('should-hide');
        // }

        if (text && addButtonText) addButtonText.textContent = text;
        if (text && mobileStickyATC && mobileStickyATCText !== null && mobileStickyATCText !== null)
          mobileStickyATCText.textContent = text;
      } else {
        this.setButtonState(addButton, true);
        if (mobileStickyATCButton) {
          this.setButtonState(mobileStickyATCButton, true);
          mobileStickyATCText.textContent = window.variantStrings.addToCart;
        }

        addButtonText.textContent = window.variantStrings.addToCart;

        // if (mobileStickyATC) {
        //   mobileStickyATC.classList.remove('should-hide');
        // }
      }
    } else if (birthlistMode === true && addButton !== null) {
      // In this case the button is the birthlist button
      const mobileStickyATC = document.querySelector('sticky-mobile-atc');
      const mobileStickyATCButton = mobileStickyATC?.querySelector('button[name="add"]');
      const mobileStickyATCText = mobileStickyATC?.querySelector('[data-add-to-cart-button-text]');

      // Check if the product is a dropship product
      if (this.dataset.dropship === 'true') {
        this.setButtonState(addButton, true);
        this.setButtonState(mobileStickyATCButton, true);
        if (addButton.querySelector('[data-add-to-cart-button-text]'))
          addButton.querySelector('[data-add-to-cart-button-text]').textContent =
            window.variantStrings.addToBirthlist;
        if (mobileStickyATCText)
          mobileStickyATCText.textContent = window.variantStrings.addToBirthlist;
      } else {
        // Dropship is false
        const qtyArray = JSON.parse(addButton.dataset.variantQuantities);
        const matchedQty = qtyArray[this.currentVariant.id];

        if (matchedQty <= 0) {
          // If the quantity is less than 0, disable the button
          this.setButtonState(addButton, false);
          this.setButtonState(mobileStickyATCButton, false);
          if (text && addButton.querySelector('[data-add-to-cart-button-text]'))
            addButton.querySelector('[data-add-to-cart-button-text]').textContent = text;
          if (text && mobileStickyATCText !== null) mobileStickyATCText.textContent = text;
        } else if (matchedQty > 0) {
          // If the quantity is greater than 0, enable the button
          this.setButtonState(addButton, true);
          this.setButtonState(mobileStickyATCButton, true);
          addButton.querySelector('[data-add-to-cart-button-text]').textContent =
            window.variantStrings.addToBirthlist;
          mobileStickyATCText.textContent = window.variantStrings.addToBirthlist;
        }
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}
class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.updateOptions();
    this.updateMasterId();
    this.highlightOptions();

    this.querySelectorAll('[data-option-label]').forEach((radio) => {
      radio.addEventListener('click', () => {
        const trigger = radio
          .closest('fieldset')
          .querySelector('[data-collapsible-trigger]:not([data-backdrop])');
        trigger.querySelector('[data-current-variant]').innerHTML =
          radio.querySelector('[data-option-value]').innerHTML;
        trigger.toggle();
      });
    });
  }

  onVariantChange() {
    super.onVariantChange();
    this.highlightOptions();
    this.removeHighlight();
  }

  removeHighlight() {
    const noVariantElements = document.querySelectorAll('[data-no-variant]');
    noVariantElements.forEach((element) => {
      element.classList.remove('border-red-shade-1');
    });

    const variantErrorMessage = document.querySelectorAll('.variant-error-message');
    variantErrorMessage.forEach((element) => {
      element.classList.remove('flex');

      element.classList.add('hidden');
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }

  /*
   * Check for each option value if the other one/two selected variant options are available
   */
  highlightOptions() {
    // If no selected element make all available
    let selectedElement = event
      ? event.target
      : this.querySelector('[data-option-group] input[checked]');
    if (!selectedElement) {
      this.querySelectorAll('[data-option-group]').forEach((option) => {
        option.querySelectorAll('[data-option]').forEach((optionEl) => {
          let label = optionEl.querySelector('[data-option-label]');
          label.classList.remove('option__label--disabled');
        });
      });
      return;
    }

    // Loop over option groups
    this.querySelectorAll('[data-option-group]').forEach((option) => {
      // Get index from option group (1, 2 or 3)
      const optionIndex = parseInt(option.dataset.optionGroup);

      // Create compare options from group, remove selected option based on index
      const compareOptions = [...this.options].filter((option, index) => index != optionIndex);

      // Loop over possible values for option group
      option.querySelectorAll('[data-option]').forEach((optionEl) => {
        optionEl.querySelector('[data-option-label]');
          let input = optionEl.querySelector('[data-option-input]'),
          value = input.value;

        // Match option availability and check if the two current options are available for value
        this.getVariantData().filter((variant) => {
          // Get available variants where the current option index is the option value
          if (variant.options[optionIndex] == value && variant.available) {
            // Create variant options, remove option based on option value
            const variantOptions = [...variant.options].filter(
              (option, index) => index != optionIndex
            );

            // Check if compare options is the same as variant options
            return variantOptions.every(
              (item, index) => item.toLowerCase() === compareOptions[index]?.toLowerCase()
            );
          }

          return false;
        });

        // Debug current index, current value, compare options and match
        // console.log(optionIndex, value, compareOptions, match);

        // Enable disable variant options
        // label.classList.toggle('option__label--disabled', match.length == 0);
      });
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
